/**
 * @fileoverview Agent definition for critique-committee-v2.
 *
 * This is a COMPOSITE agent that orchestrates four specialized critique agents
 * in parallel to provide multi-perspective prose analysis:
 * 1. critique-prose-flow: Rhythm, pacing, sentence variety, transitions
 * 2. critique-sensory-atmosphere: Sensory details, atmosphere, immersion
 * 3. critique-voice-emotion: Voice consistency, emotional resonance
 * 4. critique-dialogue: Dialogue craft, character voice, subtext, exposition
 *
 * @category narrative.prose.review
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'critique-committee-v2',
  kind: 'composite',
  name: 'Critique Committee',
  description: 'Runs four specialized critique agents in parallel to analyze prose from multiple perspectives (flow, atmosphere, voice, dialogue).',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: [
      'use-critique-committee-v2.ts',
      'use-critique-workflow.ts',
    ],
    // Composite agents specify which primitives they orchestrate
    composedOf: [
      'critique-prose-flow',
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
      'critique-dialogue',
    ],
    relatedAgents: [
      'critique-prose-flow',
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
      'critique-dialogue',
      'iterative-refinement-v2',
    ],
    taxonomyPath: 'narrative.prose.review',
  },
};
